import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { axiosGet, axiosPost } from "../../api/Axios";

const initialState: IGeneralConfigs = {
  isError: false,
  errors: [],
  isLoading: false,
  isShowTableInDesktop: true,
};
const resetErrorState = (state: IGeneralConfigs) => {
  state.isError = false;
};
const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setIsShowTableInDesktop: (state, action) => {
      state.isShowTableInDesktop = action.payload;
    },
  },

  extraReducers: () => {},
});

export const { setIsShowTableInDesktop } = generalSlice.actions;
export default generalSlice.reducer;
